export default {
  dashboard: "Dashboard",
  perfectMoney: {
    mainTitle: "Perfect Money",
    buy: "Buy Perfect Money",
    sell: "Sell Perfect Money"
  },
  order: "Order Placement",
  orderProcess: {
    depositProcess: "Deposit",
    offlineDepositProcess: "Deposit",
    depositResubmitProcess: "Wallets",
    withdrawalProcess: "Withdrawal",
    withdrawalRialProcess: "Withdrawal",
    withdrawalCryptoProcess: "Withdrawal",
    exchangeProcess: "Exchange",
    transferProcess: "Transfer"
  },
  walletOrder: "Wallets",
  wallet: {
    main: "Main Wallet",
    spot: "Spot Wallet"
  },
  tickets: {
    mainTitle: "Tickets",
    createTicket: "Tickets",
    singleTicket: "Tickets",
    ticketList: "Tickets"
  },
  gifts: "Gifts",
  referral: "Invite Friends",
  operations: {
    deposit: "Wallets",
    withdrawal: "Wallets",
    exchange: "Exchange",
    transfer: "Wallets"
  },
  transactionOrder: {
    deposits: "Transaction History",
    withdrawals: "Transaction History",
    exchanges: "Transaction History",
    transfers: "Transaction History"
  },
  account: "Account Settings",
  Markets: {
    market: "Markets"
  },
  staking: {
    mainTitle: "استخرهای مشارکت و استیکینگ"
  }
};
